export default {
  _maxRetry: 1,
  _retry: true,
  get(key, parse) {
    let val
    try {
      val = localStorage.getItem(key)
      if (val) {
        return parse ? JSON.parse(val) : val
      } else {
        return undefined
      }
    } catch (e) {
      return undefined
    }
  },
  set(key, val, retry) {
    retry = typeof retry === "undefined" ? this._retry : retry
    try {
      localStorage.setItem(key, val)
    } catch (e) {
      // 当超过最大限制的时候，清除缓存，后续考虑白名单清除
      if (e && e.toString().indexOf("QuotaExceededError") !== -1) {
        localStorage.clear()
      }
      if (retry) {
        let max = this._maxRetry
        while (max > 0) {
          max--
          this.set(key, val, false)
        }
      }
    }
  },
  del(key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      return undefined
    }
  }
}
